import React from 'react'
import { Typography, Button } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import ModalWrapper from './ModalWrapper'
import { BasicModalProps } from '../../types/modals'
import './Modals.css'

const { Title, Paragraph } = Typography

export const ContactUsModal: React.FC<BasicModalProps> = ({
    isOpen,
    onClose,
}) => {
    const { t } = useTranslation()

    const handleClick = () => {
        window.open('https://wa.me/+4915566041933', '_blank')
    }

    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            width={862}
            className="contactus-modal"
        >
            <div data-testid="contact-modal" className="modal-content">
                <div className="contactus-modal-container">
                    <div className="contactus-modal-content">
                        <div className="text-container">
                            <Title className="title" level={2}>
                                {t('modals.contactUs.title')}
                            </Title>
                            <Paragraph className="paragraph">
                                {t('modals.contactUs.description')}
                            </Paragraph>

                            <div className="email-contact">
                                <MailOutlined />
                                <Paragraph className="email-text">
                                    {t('modals.contactUs.email')}
                                </Paragraph>
                            </div>

                            <div className="whatsapp-button-container">
                                <Button
                                    className="whatsapp-button"
                                    onClick={handleClick}
                                >
                                    {t('modals.contactUs.whatsapp')}
                                </Button>
                            </div>
                        </div>
                        <div className="image-group">
                            <div className="image">
                                <img
                                    src="/img/Contactus.png"
                                    alt={t('common.alt.contact')}
                                />
                            </div>
                        </div>
                        <div className="single-mobile-image">
                            <img
                                src="/img/Contactus.png"
                                alt={t('common.alt.contact')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ModalWrapper>
    )
}
